export class ApiError extends Error {
    constructor({
        message = 'Ошибка запроса',
        status = null,
        code = null,
        data = null,
        url = null,
        method = null,
        originalError = null,
    } = {}) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.data = data;
        this.url = url;
        this.method = method;
        this.originalError = originalError;
        this.isApiError = true;
        this.isAuthError = status === 401 || status === 403;
        this.isNetworkError = !status && Boolean(originalError?.request);
    }
}

const extractMessage = (data, fallback) => {
    if (!data) {
        return fallback;
    }

    if (typeof data === 'string') {
        return data;
    }

    if (typeof data.message === 'string') {
        return data.message;
    }

    if (typeof data.error === 'string') {
        return data.error;
    }

    if (Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors
            .map((item) => typeof item === 'string' ? item : item?.message)
            .filter(Boolean)
            .join('\n');
    }

    return fallback;
};

export const normalizeApiError = (error, fallbackMessage = 'Ошибка запроса') => {
    if (error?.isApiError) {
        return error;
    }

    const response = error?.response;
    const requestConfig = error?.config || response?.config || {};
    const status = response?.status || null;
    const data = response?.data || null;

    let message = extractMessage(data, fallbackMessage);

    if (!response && error?.request) {
        message = 'Нет соединения с сервером или сервер не отвечает';
    }

    if (error?.code === 'ECONNABORTED') {
        message = 'Превышено время ожидания ответа сервера';
    }

    return new ApiError({
        message,
        status,
        code: error?.code || null,
        data,
        url: requestConfig.url || null,
        method: requestConfig.method || null,
        originalError: error,
    });
};

export const getApiErrorMessage = (error, fallbackMessage = 'Ошибка запроса') => {
    return normalizeApiError(error, fallbackMessage).message;
};
